
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Commas`}</h1>
<p>{`Always use an additional trailing comma at the end of the line.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Cleaner diffs and easier modifications.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const point = {
  x: 2,
  y: 2
};

const items = [
  'item1',
  'item2'
];

function foo(
  bar,
  baz
) {
}

// Good
const point = {
  x: 2,
  y: 2,
};

const items = [
  'item1',
  'item2',
];

function foo(
  bar,
  baz,
) {
}
`}</code></pre>
<p>{`Never use a trailing comma when it's not at the end of the line.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const point = { x: 2, y: 2, };
const items = ['item1', 'item2',];
function foo(bar, baz,) {
}

// Good
const point = { x: 2, y: 2 };
const items = ['item1', 'item2'];
function foo(bar, baz) {
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;